import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Text, ActionButton, Icon, InputFieldV2 } from '../custom-components';
import { IcClose, IcChevronRight, IcChevronLeft } from '../custom-components/Icon';
import '../styles/addCategoryModal.css';
import '../styles/masterSetup.css';

import { getTranslations } from '../utils/translationApi';

import { languages } from '../utils/languages';

const EditCategoryModal = ({ onClose, category, onUpdate }) => {
  const [activeLanguage, setActiveLanguage] = useState(languages[0].value);
  const [startIndex, setStartIndex] = useState(0);
  const [cookieName, setCookieName] = useState(category.category);
  const [description, setDescription] = useState(category.description);
  const tenant_id = useSelector((state) => state.common.tenant_id);
  const business_id = useSelector((state) => state.common.business_id);
  const visibleLanguages = 6;

  React.useEffect(() => {
    const translateInputs = async () => {
      if (!cookieName && !description) return;

      const textsToTranslate = [];
      if (cookieName) textsToTranslate.push({ id: 'cookieName', source: cookieName });
      if (description) textsToTranslate.push({ id: 'description', source: description });

      if (textsToTranslate.length === 0) return;

      try {
        const translationResult = await getTranslations(textsToTranslate, activeLanguage);

        // Check if translationResult and output exist
        if (!translationResult || !translationResult.output || !Array.isArray(translationResult.output)) {
          console.error('Invalid translation result structure:', translationResult);
          // Keep original values if translation fails
          return;
        }

        const translatedName = translationResult.output.find(t => t.id === 'cookieName')?.target || cookieName;
        const translatedDesc = translationResult.output.find(t => t.id === 'description')?.target || description;

        setCookieName(translatedName);
        setDescription(translatedDesc);
      } catch (error) {
        console.error('Error translating inputs:', error);
        // Keep original values if translation fails
      }
    };

    if (activeLanguage !== 'en') {
      translateInputs();
    }
  }, [activeLanguage, cookieName, description]);


  const handleNext = () => {
    if (startIndex + visibleLanguages < languages.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const handleUpdate = () => {
    if (cookieName && description) {
      onUpdate(cookieName, description);
    }
  };

  return (
    <div className="modal-outer-container">
      <div className="master-set-up-modal-container">
        <div className="modal-close-btn-container">
          <ActionButton onClick={onClose} icon={<IcClose />} kind="tertiary" />
        </div>
        <Text appearance="heading-xs">Edit cookie category</Text>
        <div className="language-tabs-container">
          <div
            className="arrow-btn"
            onClick={handlePrev}
            disabled={startIndex === 0}
          >
            <Icon ic={<IcChevronLeft />} color="#0ea5e9" />
          </div>
          <div className="language-tabs">
            {languages.slice(startIndex, startIndex + visibleLanguages).map(lang => (
              <div
                key={lang.value}
                className={`language-tab ${activeLanguage === lang.label ? 'active' : ''}`}
                onClick={() => setActiveLanguage(lang.value)}
              >
                <Text appearance={activeLanguage === lang.label ? "body-s-bold" : "body-s"}>{lang.label}</Text>
              </div>
            ))}
          </div>
          <div
            className="arrow-btn"
            onClick={handleNext}
            disabled={startIndex + visibleLanguages >= languages.length}
          >
            <Icon ic={<IcChevronRight />} color="#0ea5e9" />
          </div>
        </div>
        <div className="form-container">
          <InputFieldV2 label="Cookie name" value={cookieName} onChange={(e) => setCookieName(e.target.value)} />
          <div className="description-container">
            <Text as="label" htmlFor="description">Description</Text>
            <textarea id="description" rows="4" value={description} onChange={(e) => setDescription(e.target.value)} />
          </div>
        </div>
        <div className="modal-add-btn-container">
          <ActionButton label="Update" kind="primary" onClick={handleUpdate} />
        </div>
      </div>
    </div>
  );
};

export default EditCategoryModal;
